import styled from "styled-components";

export const Text = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
